import React, {useEffect} from 'react'
import moment from 'moment';
import 'moment/locale/ca';

const NotificationHoursES = ({hours}) => { 
  moment.locale('ca');
  useEffect(() => {
    // console.log('hours CA', hours);
  }, [])
  
  return (
    <p className="msg-notification-time">{moment(hours).startOf('second').fromNow()}</p>
  )
}

export default NotificationHoursES;
